/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HbsConfirmUploadResponseNotification } from './HbsConfirmUploadResponseNotification';
import {
    HbsConfirmUploadResponseNotificationFromJSON,
    HbsConfirmUploadResponseNotificationFromJSONTyped,
    HbsConfirmUploadResponseNotificationToJSON,
    HbsConfirmUploadResponseNotificationToJSONTyped,
} from './HbsConfirmUploadResponseNotification';

/**
 * Réponse de confirmation d'upload d'une remise HBS (OperationResponse). En cas de succès, notification.message vaut par ex. « Upload confirmé : N contrat(s) de la remise du JJ/MM/AAAA. » et est affichée automatiquement côté front.
 * 
 * @export
 * @interface HbsConfirmUploadResponse
 */
export interface HbsConfirmUploadResponse {
    /**
     * Indique si la confirmation a réussi
     * @type {boolean}
     * @memberof HbsConfirmUploadResponse
     */
    isSuccess?: boolean;
    /**
     * Message d'erreur détaillé en cas d'échec
     * @type {string}
     * @memberof HbsConfirmUploadResponse
     */
    errorMessage?: string | null;
    /**
     * 
     * @type {HbsConfirmUploadResponseNotification}
     * @memberof HbsConfirmUploadResponse
     */
    notification?: HbsConfirmUploadResponseNotification | null;
}

/**
 * Check if a given object implements the HbsConfirmUploadResponse interface.
 */
export function instanceOfHbsConfirmUploadResponse(value: object): value is HbsConfirmUploadResponse {
    return true;
}

export function HbsConfirmUploadResponseFromJSON(json: any): HbsConfirmUploadResponse {
    return HbsConfirmUploadResponseFromJSONTyped(json, false);
}

export function HbsConfirmUploadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HbsConfirmUploadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'] == null ? undefined : json['isSuccess'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'notification': json['notification'] == null ? undefined : HbsConfirmUploadResponseNotificationFromJSON(json['notification']),
    };
}

export function HbsConfirmUploadResponseToJSON(json: any): HbsConfirmUploadResponse {
    return HbsConfirmUploadResponseToJSONTyped(json, false);
}

export function HbsConfirmUploadResponseToJSONTyped(value?: HbsConfirmUploadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'errorMessage': value['errorMessage'],
        'notification': HbsConfirmUploadResponseNotificationToJSON(value['notification']),
    };
}

